import { render, staticRenderFns } from "./preloader.vue?vue&type=template&id=2389c993&scoped=true"
import script from "./preloader.vue?vue&type=script&lang=js"
export * from "./preloader.vue?vue&type=script&lang=js"
import style0 from "./preloader.vue?vue&type=style&index=0&id=2389c993&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2389c993",
  null
  
)

export default component.exports